export class SearchSupportRequestReq {
  userId: number;
  searchTerm: string;
  supportType: string;
  supportStatus: string;
  isActive: boolean;
  dateFrom: Date | null;
  dateTo: Date | null;
  pageIndex: number;
  itemsCount: number;

}

export interface SearchSupportRequestRes {
  id: number;
  userId: number;
  userName: string;
  userPhotoUrl: string;
  supportTypeId: number;
  supportType: string;
  description: string;
  supportStatus: string;
  createdDate: Date;
  modifiedDate: string;
  isActive: boolean;
  attachments: SupportRequestAttachmentRes[];
}


export class SupportRequestAttachmentRes {
  id: number;
  attachmentContentType: string;
  fileName: string;
  attachmentUrl: string;
  createdDate: string;
}
